export const META_TYPE = 'userAsset';
export const META_VER = 'v1';

export const CMD_USERASSET_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
